import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../services/auth';

const PublicRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // Verificar si hay token en localStorage
        const hasToken = authService.isAuthenticated();
        
        if (!hasToken) {
          setIsAuthenticated(false);
          setIsLoading(false);
          return;
        }

        // Verificar token con el backend
        const user = await authService.getCurrentUserFromBackend();
        
        setIsAuthenticated(!!user);
      } catch (error) {
        // Si hay error, asumir que no está autenticado
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (isLoading) {
    // Mostrar un loading mientras se verifica la autenticación
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-white text-lg">Cargando...</div>
      </div>
    );
  }

  if (isAuthenticated) {
    // Si está autenticado, redirigir según el rol
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        if (user.role === 'admin') {
          return <Navigate to="/admin" replace />;
        } else if (user.role === 'closer') {
          return <Navigate to="/closer" replace />;
        } else if (user.role === 'tienda') {
          // TODO: Implementar dashboard para tiendas
          return <Navigate to="/home" replace />;
        }
      } catch (error) {
        console.error('Error parsing user data:', error);
      }
    }
    // Por defecto, redirigir al home
    return <Navigate to="/home" replace />;
  }

  return children;
};

export default PublicRoute;

